/**
 * Created by Abner Sui on 05/08/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 05/24/2019 Bowen Li: changed the float menu showing
 */

import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { BriefConfig } from '../../widgets/widgets.model';
import { EmailDigest, EmailSection, SectionColumn, SectionType, EmailDigestType } from '../../tamalelibs/models/emaildigest.model';
import { Subscription, forkJoin, Observable, of } from 'rxjs';
import { AppState } from '../../redux';
import { Store, select, createSelector } from '@ngrx/store';
import { emailDigestConfigSelector } from '../../redux/reducers/email-digest.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailDigestService } from '../../services/email-digest.service';
import { StoreQuerierService } from '../../services/store-querier.service';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { EmailDigestDialogEvents, EmailDigestDialogActions } from '../../components/email-digest/email-digest.model';
import { EmailDigestActionTypes } from '../../redux/actions/email-digest.actions';
import * as lodash from 'lodash';
import { filter, take, switchMap, map, catchError } from 'rxjs/operators';
import { DataModelBase } from '../../tamalelibs/models/base.model';
import { fullEntityTypeSelector } from '../../redux/reducers/entity-type.reducer';
import { fullEntryTypeSelector } from '../../redux/reducers/entry-type.reducer';
import { adhocSelector, adhocTitleSelector } from '../../redux/reducers/adhoc.reducer';
import { WizardMenuConfig, WizardMenuEventType } from '../../widgets/wizard-menu/wizard-menu.config';
import { EmailDigestSubChromeEventTypes } from './email-digest-editor.model';
import { DEFAULT_ITEM_HEIGHT } from '../../components/dashboard/tile-setting/tile-column-setting/tile-column-setting.model';
import { Adhoc } from '../../tamalelibs/models/adhoc.model';
import { BriefObject } from '../../tamalelibs/models/brief-object';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { IdHelperService } from '../../services/id-helper.service';
import { FloatMenuService } from '../../services/float-menu.service';
import { EmailDigestServiceCommon } from '../../components/email-digest/email-digest-common.service';
import { UtilsService } from '../../tamalelibs/services/utils.service';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { AppConfig } from '../../tamalelibs/models/app-config.model';
import { ArrayHelperService } from '../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'tam-email-digest-editor',
    templateUrl: './email-digest-editor.component.html',
    styleUrls: ['./email-digest-editor.component.scss'],
})
export class EmailDigestEditorComponent implements OnInit, OnDestroy {

    @ViewChild('keywordForAddInput', { static: false })
    keywordForAddInputEle: ElementRef;
    @ViewChild('addListContainer', { static: false })
    addListContainerEle: ElementRef;
    @ViewChild('sectionBox', { static: false })
    sectionBox: ElementRef;

    subChromeConfig: BriefConfig = new BriefConfig();
    // name, description, scheduler, minuteOffset, recipients, hideBlankEmail, hideBlankSection, schedulerStr
    // emailSection
    emailDigest: EmailDigest;
    currentUser: SystemUser;
    id: string;
    isPageLoading = true;
    recipientsStr: string;
    recipientsSource: Array<DataModelBase>;
    selectedSection: EmailSection;
    wizardConfig: WizardMenuConfig = new WizardMenuConfig();
    isPreviewing = false;
    selectedColumn: SectionColumn;
    selectedColumnIndex: number;
    selectedColumnIndexForAdd: number;
    showAddPopup = false;
    addSearchResult: Array<SectionColumn> = [];
    keywordForAdd: string;
    selectedDisplay: BriefObject;
    displayList: Array<BriefObject> = [
        {
            id: 'shortName',
            value: 'Short Name',
        },
        {
            id: 'longName',
            value: 'Long Name',
        },
    ];
    showSubject: boolean;
    showBlurb: boolean;
    rowList: Array<BriefObject> = [
        {
            id: -1,
            value: 'All',
        },
        {
            id: 5,
            value: '5',
        },
        {
            id: 10,
            value: '10',
        },
        {
            id: 30,
            value: '30',
        },
        {
            id: 50,
            value: '50',
        },
    ];
    selectedRowNumber: BriefObject;
    sortByList: Array<BriefObject> = [];
    selectedSortBy: BriefObject;
    sortOrderList: Array<BriefObject> = [
        {
            id: -1,
            value: 'All',
        },
        {
            id: 5,
            value: '5',
        },
        {
            id: 10,
            value: '10',
        },
        {
            id: 30,
            value: '30',
        },
        {
            id: 50,
            value: '50',
        },
    ];
    selectedSortOrder: BriefObject;
    contextMenuConfig: ContextMenuConfig;
    previewSectionId: string;
    previewNoResultKeyword = '<img width="75" height="75" src="https://image.ibb.co/jAdBsU/no_Results_Found.png">';
    adhocs: Array<Adhoc>;

    private _preDigest: EmailDigest;
    private _columnList: Array<SectionColumn> = [];
    private _noteColumnList: Array<SectionColumn> = [];
    private _fileColumnList: Array<SectionColumn> = [];
    private _standardDateColumn: Array<string> = ['displayDate', 'lastEditedDate', 'submittedDate'];
    private _dateSortOrderList: Array<BriefObject> = [
        {
            id: 'asc',
            value: 'Oldest On Top',
        },
        {
            id: 'desc',
            value: 'Newest On Top',
        },
    ];
    private _nonDateSortOrderList: Array<BriefObject> = [
        {
            id: 'asc',
            value: 'Ascending',
        },
        {
            id: 'desc',
            value: 'Descending',
        },
    ];
    private _noteSortByList: Array<BriefObject> = [
        {
            id: 'displayDate',
            value: 'Display Date',
        },
        {
            id: 'lastEditedDate',
            value: 'Last Modified Date',
        },
        {
            id: 'submittedDate',
            value: 'Submitted Date',
        },
    ];
    private _fileSortByList: Array<BriefObject> = [
        {
            id: 'displayDate',
            value: 'Display Date',
        },
        {
            id: 'submittedDate',
            value: 'Submitted Date',
        },
    ];
    private _selectedSectionClone: EmailSection;
    private _isCopy = false;
    private _navigateBySelf = false;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _store: Store<AppState>,
        private _router: ActivatedRoute,
        private _route: Router,
        private _emailDigestService: EmailDigestService,
        private _emailDigestServiceCommon: EmailDigestServiceCommon,
        private _storeQuerier: StoreQuerierService,
        private _toast: ToastService,
        private _alert: AlertWindowService,
        private _floatMenuService: FloatMenuService,
        private _utils: UtilsService,
    ) { }

    ngOnInit() {
        this.isPageLoading = true;
        this._floatMenuService.floatMenuBottomSubject$.next(false);
        const constantDataReadySelector = createSelector(
            fullEntityTypeSelector,
            fullEntryTypeSelector,
            adhocSelector,
            (state: AppState) => state.relationshipType,
            (allEntityTypes, allEntryTypes, adhoc, allRelationshipTypes) => {
                if (allEntityTypes && allEntityTypes.length > 0 &&
                    allEntryTypes && allEntryTypes.length > 0 &&
                    allRelationshipTypes && allRelationshipTypes.length > 0 &&
                    adhoc && adhoc.title && adhoc.db) {
                    return true;
                } else {
                    return false;
                }
            }
        );
        this._store.pipe(
            select(constantDataReadySelector),
            filter(isReady => isReady),
            switchMap(() => {
                return this._initializeAgainstDifferentEntrance();
            }),
            take(1),
        ).subscribe(() => {
            this.isPageLoading = false;
        });
        this._initContextMenu();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._floatMenuService.floatMenuBottomSubject$.next(true);
    }

    @HostListener('document:click', ['$event'])
    clickSomewhere(event) {
        if (this.showAddPopup) {
            this.showAddPopup = false;
        }
    }

    emptyClick($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    isDirty(): boolean {
        if (this.id === 'new' || this._isCopy) {
            return !this._navigateBySelf;
        } else {
            return this._navigateBySelf ? false : !this._isSameDigest(this.emailDigest, this._preDigest);
        }
    }

    onAddColumn(event) {
        this.selectedColumnIndexForAdd = 0;
        this.showAddPopup = !this.showAddPopup;
        this.keywordForAdd = '';
        if (this.showAddPopup) {
            this.addSearchResult = this._columnList;
        }
        this.selectedColumnIndexForAdd = 0;
        setTimeout(() =>
            this.keywordForAddInputEle.nativeElement.focus()
        );
        this.emptyClick(event);
    }

    onAddColumnClick($event, item: SectionColumn, index: number) {
        const column: SectionColumn = lodash.cloneDeep(item);
        this.selectedSection.displaySetting.column.push(column);
        this.selectedColumn = column;
        this.selectedColumnIndex = index;
        this._initSortByList();
        this.emptyClick($event);
    }

    onAddListKeydown(event) {
        // use up/down/enter to select through items
        if (event.keyCode === 40) { // down
            if (this.selectedColumnIndexForAdd < this.addSearchResult.length - 1) {
                this.selectedColumnIndexForAdd++;
                const nextIndex = this.selectedColumnIndexForAdd + 1;
                if (nextIndex < this.addSearchResult.length) {
                    if ((nextIndex + 1) * DEFAULT_ITEM_HEIGHT > (this.addListContainerEle.nativeElement.clientHeight + this.addListContainerEle.nativeElement.scrollTop)) {
                        // handle tha case that selected item below the visible area
                        this.addListContainerEle.nativeElement.scrollTop = (nextIndex + 1) * DEFAULT_ITEM_HEIGHT - this.addListContainerEle.nativeElement.clientHeight;
                    } else if (this.addListContainerEle.nativeElement.scrollTop > (nextIndex + 1) * DEFAULT_ITEM_HEIGHT) {
                        // handle the case that selected item above the visible area
                        this.addListContainerEle.nativeElement.scrollTop = nextIndex * DEFAULT_ITEM_HEIGHT;
                    }
                }
            }
        } else if (event.keyCode === 38) { // up
            if (this.selectedColumnIndexForAdd > 0) {
                this.selectedColumnIndexForAdd--;
                const nextIndex = this.selectedColumnIndexForAdd - 1;
                if (nextIndex >= 0) {
                    if ((nextIndex + 1) * DEFAULT_ITEM_HEIGHT > (this.addListContainerEle.nativeElement.clientHeight + this.addListContainerEle.nativeElement.scrollTop)) {
                        // handle tha case that selected item below the visible area
                        this.addListContainerEle.nativeElement.scrollTop = (nextIndex + 1) * DEFAULT_ITEM_HEIGHT - this.addListContainerEle.nativeElement.clientHeight;
                    } else if (this.addListContainerEle.nativeElement.scrollTop > nextIndex * DEFAULT_ITEM_HEIGHT) {
                        // handle the case that selected item above the visible area
                        this.addListContainerEle.nativeElement.scrollTop = nextIndex * DEFAULT_ITEM_HEIGHT;
                    }
                }
            }
        } else if (event.keyCode === 13) { // Enter
            if (this.addSearchResult && this.addSearchResult.length) {
                this.onAddColumnClick(event, this.addSearchResult[this.selectedColumnIndexForAdd], this.selectedColumnIndexForAdd);
            }
        }
    }

    onAddSection(event, type: number, section: EmailSection = null) {
        let tempSection: EmailSection;
        let sectionIndex: number;
        if (type === 0) {
            tempSection = this._emailDigestService.getDefaultNoteSection();
            this.emailDigest.emailSection.push(tempSection);
            sectionIndex = this.emailDigest.emailSection.length - 1;
        } else if (type === 1) {
            tempSection = this._emailDigestService.getDefaultFileSection();
            this.emailDigest.emailSection.push(tempSection);
            sectionIndex = this.emailDigest.emailSection.length - 1;
        } else if (section) {
            tempSection = section;
            this.emailDigest.emailSection.push(tempSection);
            sectionIndex = this.emailDigest.emailSection.length - 1;
        }
        this.onEditSection(event, tempSection, sectionIndex);
        setTimeout(
            () => {
                this.sectionBox.nativeElement.scrollTop = this.sectionBox.nativeElement.scrollHeight;
            }
        );
    }

    onAddSectionStart(event) {
        if (this.preview(event)) {
            this.onAddSection(event, null);
        }
    }

    onChangeColumnDisplay(event) {
        if (this.selectedColumn && !this.selectedColumn.display) {
            this.selectedColumn.display = this._emailDigestService.generateColumn(this.selectedColumn.field, this.adhocs.find(item => item.id === this.selectedColumn.field)).display;
        }
        this._initSortByList();
    }

    onChangeDisplay(value: BriefObject) {
        this.selectedDisplay = value;
        this.selectedColumn.format = this.selectedDisplay.id;
    }

    onChangeRow(value: BriefObject) {
        this.selectedRowNumber = value;
        if (this.selectedRowNumber && this.selectedSection) {
            this.selectedSection.displaySetting.row = this.selectedRowNumber.id;
        }
    }

    onChangeShowBlurb(value: boolean) {
        this.showBlurb = value;
        if (value === true) {
            if (this.selectedSection && !this.selectedSection.displaySetting.fixedColumn.includes('blurb')) {
                this.selectedSection.displaySetting.fixedColumn.push('blurb');
            }
        } else if (value === false) {
            if (this.selectedSection && this.selectedSection.displaySetting.fixedColumn.includes('blurb')) {
                this.selectedSection.displaySetting.fixedColumn.pop();
            }
        }
        this._validateCurrentSectionColumns();
    }

    onChangeShowSubject(value: boolean) {
        this.showSubject = value;
        if (value === true) {
            if (this.selectedSection && !this.selectedSection.displaySetting.fixedColumn.includes('subject')) {
                this.selectedSection.displaySetting.fixedColumn.unshift('subject');
            }
        } else if (value === false) {
            if (this.selectedSection && this.selectedSection.displaySetting.fixedColumn.includes('subject')) {
                this.selectedSection.displaySetting.fixedColumn.splice(0, 1);
            }
        }
        this._validateCurrentSectionColumns();
    }

    onChangeSortby(value: BriefObject) {
        this.selectedSortBy = value;
        if (this.selectedSection) {
            if (this.selectedSortBy) {
                this.selectedSection.displaySetting.sortBy = this.selectedSortBy.id;
                const sortColumn: SectionColumn = this.selectedSection.displaySetting.column.find(item => item.field === this.selectedSortBy.id);
                if (this._standardDateColumn.includes(this.selectedSortBy.id)) {
                    this.sortOrderList = this._dateSortOrderList;
                    this.onChangeSortorder(this.sortOrderList.find(item => item.id === this.selectedSection.displaySetting.sortOrder));
                } else if (sortColumn.dataType === 'date') {
                    this.sortOrderList = this._dateSortOrderList;
                    this.onChangeSortorder(this.sortOrderList.find(item => item.id === this.selectedSection.displaySetting.sortOrder));
                } else {
                    this.sortOrderList = this._nonDateSortOrderList;
                    this.onChangeSortorder(this.sortOrderList.find(item => item.id === this.selectedSection.displaySetting.sortOrder));
                }
            } else {
                this.selectedSortBy = this.sortByList.find(item => item.id === 'submittedDate');
                this.selectedSection.displaySetting.sortBy = this.selectedSortBy.id;
                this.sortOrderList = this._dateSortOrderList;
                this.onChangeSortorder(this.sortOrderList[1]);
            }
        } else {
            this.onChangeSortorder(null);
        }
    }

    onChangeSortorder(value: BriefObject) {
        this.selectedSortOrder = value;
        if (this.selectedSortOrder && this.selectedSection) {
            this.selectedSection.displaySetting.sortOrder = this.selectedSortOrder.id;
        }
    }

    onColumnClick(event, dataItem: SectionColumn, index: number) {
        if (this.selectedColumn && this.selectedColumn.field === dataItem.field && this.selectedColumnIndex === index) {
            this.selectedColumn = null;
            this.selectedColumnIndex = null;
        } else {
            this.selectedColumn = dataItem;
            this.selectedColumnIndex = index;
            if (this.selectedColumn && this.selectedColumn.dataType === 'entity') {
                this.selectedDisplay = this.displayList.find(item => item.id === this.selectedColumn.format);
                if (!this.selectedDisplay) { // compatible with Nexgen 1.0 data
                    this.selectedDisplay = this.displayList[0];
                }
            } else {
                this.selectedDisplay = null;
            }
        }
    }

    onDeleteColumn(event, dataItem: SectionColumn, index: number) {
        this.selectedSection.displaySetting.column.splice(index, 1);
        this._validateCurrentSectionColumns();
        this._initSortByList();
        if (this.selectedColumn && dataItem.field === this.selectedColumn.field && index === this.selectedColumnIndex) {
            this.selectedColumn = null;
            this.selectedColumnIndex = null;
        }
        this.emptyClick(event);
    }

    onEditDetail(event) {
        this._emailDigestService.dialogActionSubject$.next({
            type: EmailDigestDialogActions.EDIT,
            payload: this.emailDigest,
        });
    }

    onEditSection(event, section: EmailSection, i: number, ableToUnselect: boolean = true) {
        if ((i === null || i === undefined) || (this.selectedSection && this.selectedSection.id === this.emailDigest.emailSection[i].id)) {
            if (this._canSwitchSection()) {
                this._changeSelectedSection(null, event);
            } else {
                if (ableToUnselect) {
                    this._alert.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?', 'Please click "Apply & Preview" to apply them']).pipe(
                        take(1),
                    ).subscribe(result => {
                        if (result) {
                            this.emailDigest.emailSection[this.emailDigest.emailSection.findIndex(item => item.id === this.selectedSection.id)] = this._selectedSectionClone;
                            this._changeSelectedSection(null, event);
                        }
                    });
                }
            }
        } else {
            if (this._canSwitchSection()) {
                this._changeSelectedSection(i, event);
            } else {
                this._alert.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?', 'Please click "Apply & Preview" to apply them']).pipe(
                    take(1),
                ).subscribe(result => {
                    if (result) {
                        this.emailDigest.emailSection[this.emailDigest.emailSection.findIndex(item => item.id === this.selectedSection.id)] = this._selectedSectionClone;
                        this._changeSelectedSection(i, event);
                    }
                });
            }
        }
    }

    onMeatball(event, section: EmailSection, index: number) {
        this.contextMenuConfig.items[0].disabled = index === 0;
        this.contextMenuConfig.items[1].disabled = index === (this.emailDigest.emailSection.length - 1);
        this.contextMenuConfig.items[4].disabled = this.emailDigest.emailSection.length === 1;
        this._changeDetectorRef.detectChanges();
        this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, index));
        this.emptyClick(event);
    }

    onSearchAddKeyup(event) {
        const keyCode = event.keyCode;
        if (keyCode !== 13 && keyCode !== 38 && keyCode !== 40) {
            this._searchAddList();
        }
    }

    onSectionLoadAll(event, section: EmailSection, index: number) {
        this.emailDigest.emailSection[index].showAll = true;
        this.emailDigest.emailSection[index].previewResult = null;
        if (this.emailDigest.emailSection[index].isIncludeEvents) {
            this.emailDigest.emailSection[index].advFilter = this.emailDigest.emailSection[index].advFilter.replace(AppConfig.defaultAdvFilter, AppConfig.defaultAdvFilterNoteOrEvent);
        } else {
            this.emailDigest.emailSection[index].advFilter = this.emailDigest.emailSection[index].advFilter.replace(AppConfig.defaultAdvFilterNoteOrEvent, AppConfig.defaultAdvFilter);
        }
        this.isPreviewing = true;
        this.previewSectionId = this.emailDigest.emailSection[index].id;
        const showTimeZone = this.emailDigest.minuteOffset === this._emailDigestService.getLocalMinuteOffset() ? '' : this.emailDigest.scheduler.configuration;
        this._emailDigestService.previewSection(this.emailDigest.emailSection[index], this.emailDigest.minuteOffset, showTimeZone, this.emailDigest.scheduler.configuration).pipe(
            catchError((e: any) => {
                this.isPreviewing = false;
                return of(null);
            }),
            take(1),
        ).subscribe(
            response => {
                this.emailDigest.emailSection[index].previewResult = response;
                this.isPreviewing = false;
                if (this._selectedSectionClone && this._selectedSectionClone.id === this.previewSectionId) {
                    this._selectedSectionClone.previewResult = response;
                }
            }
        );
        this.emptyClick(event);
    }

    preview(event): boolean {
        if (!this.validateCurrentSectionName(event) || !this._validateCurrentSectionColumns()) {
            return false;
        }
        this.selectedSection.previewResult = null;
        this.selectedSection.showAll = false;
        // do not need to include events if the checkbox on email-digest-filter component is not checked.
        if (this.selectedSection.isIncludeEvents) {
            this.selectedSection.advFilter = this.selectedSection.advFilter.replace(AppConfig.defaultAdvFilter, AppConfig.defaultAdvFilterNoteOrEvent);
        } else {
            this.selectedSection.advFilter = this.selectedSection.advFilter.replace(AppConfig.defaultAdvFilterNoteOrEvent, AppConfig.defaultAdvFilter);
        }
        this._selectedSectionClone = lodash.cloneDeep(this.selectedSection);
        this.isPreviewing = true;
        this.previewSectionId = this.selectedSection.id;
        const showTimeZone = this.emailDigest.minuteOffset === this._emailDigestService.getLocalMinuteOffset() ? '' : this.emailDigest.scheduler.configuration;
        this._emailDigestService.previewSectionWithOneData(this.selectedSection, this.emailDigest.minuteOffset, showTimeZone, this.emailDigest.scheduler.configuration).pipe(
            catchError((e: any) => {
                return of(null);
            }),
            take(1),
        ).subscribe(response => {
            if (this.selectedSection) {
                this.selectedSection.previewResult = response;
                this._selectedSectionClone = lodash.cloneDeep(this.selectedSection);
            } else {
                const tempSection = this.emailDigest.emailSection.find(item => item.id === this.previewSectionId);
                if (tempSection) {
                    tempSection.previewResult = response;
                }
            }
            this.isPreviewing = false;
        });
        return true;
    }

    validateCurrentSectionName(event): boolean {
        let result = true;
        if (this.selectedSection) {
            if (!this.selectedSection.name || !this.selectedSection.name.trim()) {
                this.wizardConfig.config.active = 1;
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: StringLiteralsPipe.translate('general.required_error_message') + ': Section Name.',
                });
                result = false;
            }
            if (this.selectedSection.name && this.selectedSection.name.length > 128) {
                this.wizardConfig.config.active = 1;
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: StringLiteralsPipe.translate('general.section_name_exceed_maximum', '128')
                });
                result = false;
            }
        }
        return result;
    }

    validateAllSectionName(event): boolean {
        let validateEmpty = true;
        let validateTooLong = true;
        this.emailDigest.emailSection.forEach(item => {
            if (!item.name || !item.name.trim()) {
                item.name = item.type === SectionType.NOTE ? 'Note Section' : 'File Section';
                validateEmpty = false;
            }
            if (item.name && item.name.length > 128) {
                item.name = item.name.substr(0, 128);
                validateTooLong = false;
            }
        });
        if (!validateEmpty) {
            this._toast.notify({
                style: NotificationStyles.Error,
                message: StringLiteralsPipe.translate('general.required_error_message') + ': Section Name.',
            });
        }
        if (!validateTooLong) {
            this._toast.notify({
                style: NotificationStyles.Error,
                message: StringLiteralsPipe.translate('general.section_name_exceed_maximum', '128'),
            });
        }
        return validateEmpty && validateTooLong;
    }

    private _changeSelectedSection(i: number, event): void {
        if (this.validateCurrentSectionName(event) && this._validateCurrentSectionColumns()) {
            if (i !== null && i !== undefined) {
                this.selectedSection = this.emailDigest.emailSection[i];
                this._selectedSectionClone = lodash.cloneDeep(this.selectedSection);
                if (this.selectedSection.type === SectionType.NOTE) {
                    this._columnList = this._noteColumnList;
                } else if (this.selectedSection.type === SectionType.FILE) {
                    this._columnList = this._fileColumnList;
                }
                this.addSearchResult = this._columnList;
            } else {
                this.selectedSection = null;
                this._selectedSectionClone = null;
            }
            this.onColumnClick(event, this.selectedColumn, this.selectedColumnIndex);
            this.onChangeShowSubject(this.selectedSection ? this.selectedSection.displaySetting.fixedColumn.includes('subject') : null);
            this.onChangeShowBlurb(this.selectedSection ? this.selectedSection.displaySetting.fixedColumn.includes('blurb') : null);
            this.onChangeRow(this.selectedSection ? this.rowList.find(item => item.id === this.selectedSection.displaySetting.row) : null);
            this._initSortByList();
        }
    }

    private _create() {
        const tempDigest: EmailDigest = lodash.cloneDeep(this.emailDigest);
        tempDigest.scheduler = this._emailDigestService.parseSchedulerToParams(tempDigest.scheduler);
        tempDigest.emailSection.forEach(item => {
            delete item.previewResult;
            delete item.showAll;
        });
        delete tempDigest.author;
        delete tempDigest.createDate;
        delete tempDigest.deletable;
        delete tempDigest.editable;
        delete tempDigest.fireTime;
        delete tempDigest.isSubscribable;
        delete tempDigest.isSubscribed;
        delete tempDigest.lastModifiedDate;
        delete tempDigest.latestExecutionTime;
        delete tempDigest.schedulerStr;
        this._emailDigestServiceCommon.saveEmailDigest(tempDigest).subscribe(data => {
            if (data) {
                this._store.dispatch({
                    type: EmailDigestActionTypes.ADD_CONFIG,
                    payload: EmailDigest.parse(data),
                });
                this._toast.notify({
                    style: NotificationStyles.Success,
                    message: 'The email digest with name ' + data.name + ' successfully saved.',
                });
                this._navigateBySelf = true;
                this._route.navigate(['email-digest']);
            }
        });
    }

    private _getEmailDigestConfig(): Observable<any> {
        return this._emailDigestService.getEmailDigest(this.id).pipe(
            catchError((e: any) => {
                this._navigateBySelf = true;
                this._route.navigate(['email-digest']);
                return of(null);
            }),
            map(response => {
                this.emailDigest = this._emailDigestService.addConfigurationTimezone(EmailDigest.parse(response));
                this._store.dispatch({
                    type: EmailDigestActionTypes.GET_EMAIL_DIGEST_CONFIG_SUCCESS,
                    payload: this.emailDigest,
                });
                return this.emailDigest;
            }),
            switchMap(() => {
                return this._initData();
            })
        );
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.stateful = false;
        this.contextMenuConfig.single = true;
        this.contextMenuConfig.items = [
            { id: '0', text: 'Move section up', disabled: false },
            { id: '1', text: 'Move section down', disabled: false },
            { divider: true },
            { id: '2', text: 'Copy', disabled: false },
            { id: '3', text: 'Delete', disabled: false },
        ];
        this._destroySubscriptions.push(this.contextMenuConfig.events$.subscribe(event => this._onContextMenuSelect(event)));
    }

    private _initData(): Observable<any> {
        return this._initDetailData().pipe(
            switchMap(() => {
                const observables = [];
                const showTimeZone = this.emailDigest.minuteOffset === this._emailDigestService.getLocalMinuteOffset() ? '' : this.emailDigest.scheduler.configuration;
                this.emailDigest.emailSection.forEach(element => {
                    if (element.isIncludeEvents) {
                        element.advFilter = element.advFilter.replace(AppConfig.defaultAdvFilter, AppConfig.defaultAdvFilterNoteOrEvent);
                    } else {
                        element.advFilter = element.advFilter.replace(AppConfig.defaultAdvFilterNoteOrEvent, AppConfig.defaultAdvFilter);
                    }
                    observables.push(
                        this._emailDigestService.previewSectionWithOneData(element, this.emailDigest.minuteOffset, showTimeZone, this.emailDigest.scheduler.configuration).pipe(
                            catchError((e: any) => {
                                return of(null);
                            }),
                        ),
                    );
                });
                return forkJoin(observables).pipe(
                    map((response: any) => {
                        const length = this.emailDigest.emailSection.length;
                        for (let i = 0; i < length; i++) {
                            this.emailDigest.emailSection[i].previewResult = response[i];
                        }
                        return this.emailDigest;
                    })
                );
            }),
        );
    }

    private _initDetailData(isInit: boolean = true): Observable<any> {
        this._initRecipientsStr();
        if (this._isCopy) {
            if (isInit) {
                this.emailDigest.name = 'Copy of ' + this.emailDigest.name;
                this.emailDigest.emailSection.forEach(item => item.id = IdHelperService.createGUID());
                this.emailDigest.active = true;
                this._store.dispatch({
                    type: EmailDigestActionTypes.SET_CONFIG,
                    payload: this.emailDigest,
                });
            }
            this._emailDigestService.checkEmailDigestName(this.emailDigest.name, this.emailDigest.id).pipe(
                catchError((e: any) => {
                    const mockResult = {
                        result: false,
                    };
                    return of(mockResult);
                })
            ).subscribe(result => {
                if (!result.result) {
                    this._emailDigestService.dialogActionSubject$.next({
                        type: EmailDigestDialogActions.EDIT,
                        payload: this.emailDigest,
                    });
                    this._toast.notify({
                        style: NotificationStyles.Error,
                        message: 'One configuration with name \'' + this.emailDigest.name + '\' already exists, please enter a new one.',
                    });
                }
            });
        } else if (isInit) {
            this._preDigest = lodash.cloneDeep(this.emailDigest);
        }
        return this._emailDigestService.getFireTime(this.emailDigest).pipe(
            map(response => {
                this.emailDigest.fireTime = this._emailDigestService.parseFireTime(response.result, this._emailDigestService.getConfigContryTimezone(this.emailDigest));
                return this.emailDigest;
            }),
        );
    }

    private _initializeAgainstDifferentEntrance(): Observable<any> {
        this._store.pipe(
            select(adhocTitleSelector),
            take(1),
        ).subscribe((data: Map<string, Adhoc>) => {
            this._noteColumnList = this._emailDigestService.standardNoteColumns;
            this._fileColumnList = this._emailDigestService.standardFileColumns;
            this.adhocs = data ? Array.from(data.values()) : [];
            ArrayHelperService.sort(this.adhocs, 'name');
            this.adhocs.forEach(adhoc => {
                this._noteColumnList.push(this._emailDigestService.generateColumn(adhoc.id, adhoc));
                this._fileColumnList.push(this._emailDigestService.generateColumn(adhoc.id, adhoc));
            });
        });
        this.currentUser = this._storeQuerier.getCurrentUser();
        this.id = this._router.snapshot.params.id;
        this._isCopy = this._router.snapshot.url[1].path === 'copy';
        this._initRecipientsSource();
        this._initWizardData();
        this._destroySubscriptions.push(
            this._emailDigestService.dialogFeedbackSubject$.subscribe(event => this._onSaveEmailDigestDetail(event)),
            this.wizardConfig.events$.pipe(
                filter((item) => item.type === WizardMenuEventType.changeSelect)
            ).subscribe((item) => {
                this.wizardConfig.config.active = item.payload;
            }),
            this.subChromeConfig.feedbackSubject$.subscribe(event => this._saveCancel(event)),
        );
        return this._onSubscribeConfig(this._storeQuerier.queryBySelector(emailDigestConfigSelector));
    }

    private _initRecipientsSource() {
        const accessListSelector = createSelector(
            (state: AppState) => state.users,
            (state: AppState) => state.teams,
            (allUser, allTeam) => {
                if (allUser.length === 0 && allTeam.length === 0) {
                    return [];
                }
                const users = [...allUser];
                const teams = [...allTeam];
                return users.concat(teams);
            }
        );
        this._store.pipe(
            select(accessListSelector),
            filter((list: any) => list.length > 0),
            take(1),
        ).subscribe(list => {
            this.recipientsSource = list;
        });
    }

    private _initRecipientsStr() {
        if (this.currentUser.credential.publishPubConfiguration) {
            this.recipientsStr = this.recipientsSource.filter(item => this.emailDigest.recipients.includes(item.id)).map(item => {
                return item.name;
            }).join(', ');
        } else {
            this.recipientsStr = this.currentUser.name;
        }
    }

    private _initSortByList() {
        if (this.selectedSection) {
            if (this.selectedSection.type === SectionType.NOTE) {
                this.sortByList = lodash.cloneDeep(this._noteSortByList);
            } else {
                this.sortByList = lodash.cloneDeep(this._fileSortByList);
            }
            this.selectedSection.displaySetting.column.forEach(item => {
                if (!this._standardDateColumn.includes(item.field)) {
                    this.sortByList.push({
                        id: item.field,
                        value: item.display,
                    });
                }
            });
            this.onChangeSortby(this.sortByList.find(item => item.id === this.selectedSection.displaySetting.sortBy));
        } else {
            this.onChangeSortby(null);
        }
    }

    private _initWizardData() {
        this.wizardConfig.config.menuData = [
            {
                icon: 'filter-o',
                title: 'Filter Your Data',
            },
            {
                icon: 'config-data-source',
                title: 'Configure Your Data Source',
            },
        ];
        this.wizardConfig.config.active = 0;
    }

    private _isSameDigest(one: EmailDigest, two: EmailDigest): boolean {
        const tempOne = lodash.cloneDeep(one);
        const tempTwo = lodash.cloneDeep(two);
        delete tempOne.fireTime;
        delete tempOne.schedulerStr;
        delete tempTwo.fireTime;
        delete tempTwo.schedulerStr;
        tempOne.emailSection.forEach(item => {
            delete item.previewResult;
            delete item.showAll;
        });
        tempTwo.emailSection.forEach(item => {
            delete item.previewResult;
            delete item.showAll;
        });
        return lodash.isEqual(tempOne, tempTwo);
    }

    private _onContextMenuSelect(event) {
        const type = +event.payload.id;
        const data = event.payload.data;
        switch (type) {
            case 0:
                this._sectionMoveup(data);
                break;
            case 1:
                this._sectionMovedown(data);
                break;
            case 2:
                this._sectionCopy(data, event.payload.event);
                break;
            case 3:
                this._sectionDelete(data);
                break;
            default:
                break;
        }
    }

    private _onSaveEmailDigestDetail(event) {
        if (event.type === EmailDigestDialogEvents.SAVE) {
            const tempDigest: EmailDigest = event.payload;
            this.emailDigest.name = tempDigest.name.trim();
            this.emailDigest.description = tempDigest.description;
            this.emailDigest.hideBlankEmail = tempDigest.hideBlankEmail;
            this.emailDigest.hideBlankSection = tempDigest.hideBlankSection;
            if (this.currentUser.credential.publishPubConfiguration) {
                this.emailDigest.recipients = tempDigest.recipients;
            }
            this._initRecipientsStr();
            this.emailDigest.schedulerStr = tempDigest.schedulerStr;
            let updateScheduler = false;
            if (!this._emailDigestService.isSameScheduler(tempDigest.scheduler, this.emailDigest.scheduler)) {
                this.emailDigest.scheduler = tempDigest.scheduler;
                updateScheduler = true;
            }
            if (tempDigest.minuteOffset !== this.emailDigest.minuteOffset) {
                this.emailDigest.minuteOffset = tempDigest.minuteOffset;
                updateScheduler = true;
            }
            if (updateScheduler) {
                this._initDetailData(false).pipe(
                    take(1),
                ).subscribe(() => this.isPageLoading = false);
            }
            this._store.dispatch({
                type: EmailDigestActionTypes.SET_CONFIG,
                payload: this.emailDigest,
            });
        } else if (event.type === EmailDigestDialogEvents.CANCEL) {
            if (!this.emailDigest.name || !this.emailDigest.name.trim()) {
                this._emailDigestService.dialogActionSubject$.next({
                    type: EmailDigestDialogActions.EDIT,
                    payload: this.emailDigest,
                });
            }
        }
    }

    private _onSubscribeConfig(config: EmailDigest): Observable<any> {
        this.emailDigest = this._emailDigestService.addConfigurationTimezone(config);
        if (this.id === 'new') {
            if (!this.emailDigest) {
                const tempId = this.currentUser.credential.publishPubConfiguration ? this.currentUser.id : null;
                this.emailDigest = this._emailDigestService.getDefaultEmailDigest(EmailDigestType.SCREEN_SETTINGS, tempId);
            }
            if (!this.emailDigest.name || !this.emailDigest.name.trim()) {
                this._emailDigestService.dialogActionSubject$.next({
                    type: EmailDigestDialogActions.EDIT,
                    payload: this.emailDigest,
                });
            }
        } else {
            if (!this.emailDigest) {
                return this._getEmailDigestConfig();
            }
        }
        return this._initData();
    }

    private _saveCancel(event) {
        if (event.type === EmailDigestSubChromeEventTypes.CANCEL) {
            if (this.id === 'new' || this._isCopy) {
                this._alert.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?']).pipe(
                    take(1),
                ).subscribe(result => {
                    if (result) {
                        this._navigateBySelf = true;
                        this._route.navigate(['email-digest']);
                    }
                });
            } else {
                if (!this._isSameDigest(this.emailDigest, this._preDigest)) {
                    this._alert.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?']).pipe(
                        take(1),
                    ).subscribe(result => {
                        if (result) {
                            this._navigateBySelf = true;
                            this._route.navigate(['email-digest']);
                        }
                    });
                } else {
                    this._navigateBySelf = true;
                    this._route.navigate(['email-digest']);
                }
            }
        } else if (event.type === EmailDigestSubChromeEventTypes.SAVE) {
            if (this._validateAllSectionColumns() && this.validateAllSectionName(event)) {
                if (this.id === 'new' || this._isCopy) {
                    this._create();
                } else {
                    this._update();
                }
            } else {
                const invalidSectionIndex: number = this.emailDigest.emailSection.findIndex(item => {
                    return (item.displaySetting.column.length === 0 && item.displaySetting.fixedColumn.length === 0)
                        || !item.name || !item.name.trim() || (item.name && item.name.length > 128);
                });
                if (invalidSectionIndex > -1) {
                    this.onEditSection(event, this.emailDigest.emailSection[invalidSectionIndex], invalidSectionIndex, false);
                }
            }
        }
    }

    private _searchAddList() {
        this.selectedColumnIndexForAdd = 0;
        if (this.keywordForAdd) {
            this.addSearchResult = [];
            this._columnList.forEach(item => {
                if (item.display.toLowerCase().includes(this.keywordForAdd.toLowerCase())) {
                    this.addSearchResult.push(item);
                }
            });
        } else {
            this.addSearchResult = this._columnList;
        }
    }

    private _sectionCopy(index: number, event) {
        const tempSection: EmailSection = lodash.cloneDeep(this.emailDigest.emailSection[index]);
        tempSection.id = IdHelperService.createGUID();
        tempSection.name = 'Copy of ' + tempSection.name;
        this.onAddSection(event, null, tempSection);
    }

    private _sectionDelete(index: number) {
        const tempSections: Array<EmailSection> = this.emailDigest.emailSection.splice(index, 1);
        if (this.selectedSection && tempSections[0].id === this.selectedSection.id) {
            this.selectedSection = null;
            this._selectedSectionClone = null;
        }
    }

    private _sectionMovedown(index: number) {
        const tempSection: EmailSection = this.emailDigest.emailSection[index];
        this.emailDigest.emailSection[index] = this.emailDigest.emailSection[index + 1];
        this.emailDigest.emailSection[index + 1] = tempSection;
    }

    private _sectionMoveup(index: number) {
        const tempSection: EmailSection = this.emailDigest.emailSection[index];
        this.emailDigest.emailSection[index] = this.emailDigest.emailSection[index - 1];
        this.emailDigest.emailSection[index - 1] = tempSection;
    }

    private _update() {
        this.emailDigest.emailSection.forEach(item => {
            if (item.isIncludeEvents) {
                item.advFilter = item.advFilter.replace(AppConfig.defaultAdvFilter, AppConfig.defaultAdvFilterNoteOrEvent);
            } else {
                item.advFilter = item.advFilter.replace(AppConfig.defaultAdvFilterNoteOrEvent, AppConfig.defaultAdvFilter);
            }
        });
        const tempDigest: EmailDigest = lodash.cloneDeep(this.emailDigest);
        if (lodash.isEqual(tempDigest.scheduler, this._preDigest.scheduler)) {
            delete tempDigest.scheduler;
        } else {
            tempDigest.scheduler = this._emailDigestService.parseSchedulerToParams(tempDigest.scheduler);
        }
        if (tempDigest.minuteOffset === this._preDigest.minuteOffset) {
            delete tempDigest.minuteOffset;
        }
        tempDigest.emailSection.forEach(item => {
            delete item.previewResult;
            delete item.showAll;
        });
        this._preDigest.emailSection.forEach(item => {
            delete item.previewResult;
            delete item.showAll;
        });
        if (lodash.isEqual(tempDigest.emailSection, this._preDigest.emailSection)) {
            delete tempDigest.emailSection;
        }
        delete tempDigest.author;
        delete tempDigest.createDate;
        delete tempDigest.deletable;
        delete tempDigest.editable;
        delete tempDigest.fireTime;
        delete tempDigest.isSubscribable;
        delete tempDigest.isSubscribed;
        delete tempDigest.lastModifiedDate;
        delete tempDigest.latestExecutionTime;
        delete tempDigest.schedulerStr;
        this._emailDigestServiceCommon.updateEmailDigest(tempDigest).subscribe(data => {
            if (data) {
                this._store.dispatch({
                    type: EmailDigestActionTypes.UPDATE_CONFIG,
                    payload: EmailDigest.parse(data),
                });
                this._toast.notify({
                    style: NotificationStyles.Success,
                    message: 'The email digest with name ' + data.name + ' successfully updated.',
                });
                this._navigateBySelf = true;
                this._route.navigate(['email-digest']);
            }
        });
    }

    private _canSwitchSection(): boolean {
        if (this._selectedSectionClone) {
            return this._utils.isEqual(this._selectedSectionClone, this.selectedSection);
        } else {
            return true;
        }
    }

    private _validateCurrentSectionColumns(): boolean {
        let result = true;
        if (this.selectedSection) {
            if (this.selectedSection.displaySetting.column.length === 0 && this.selectedSection.displaySetting.fixedColumn.length === 0) {
                result = false;
            }
        }
        if (!result && this.wizardConfig.config.active === 0) {
            this._toast.notify({
                style: NotificationStyles.Error,
                message: 'Please add at least one metadata to display.',
            });
        }
        return result;
    }

    private _validateAllSectionColumns(): boolean {
        let result = true;
        this.emailDigest.emailSection.forEach(item => {
            if (item.displaySetting.column.length === 0 && item.displaySetting.fixedColumn.length === 0) {
                result = false;
            }
        });
        if (!result) {
            this._toast.notify({
                style: NotificationStyles.Error,
                message: 'Please add at least one metadata to display.',
            });
        }
        return result;
    }

}
